const TOKEN_KEY = 'access_token'
const USER_DATA_KEY = 'user_data'
const REFRESH_TOKEN_KEY = 'refresh_token'
const MFA_DEVICE_TOKEN_KEY = 'mfa_device_token'

/**
 * Manage the how Access Tokens are being stored and retreived from storage.
 *
 * Current implementation stores to localStorage. Local Storage should always be
 * accessed through this instace.
**/
const TokenService = {
    getToken() {
        return localStorage.getItem(TOKEN_KEY)
    },

    saveToken(accessToken) {
        localStorage.setItem(TOKEN_KEY, accessToken)
    },

    removeToken() {
        localStorage.removeItem(TOKEN_KEY)
    },

    getUserData() {
        var strUserData = localStorage.getItem(USER_DATA_KEY)
        // console.log('calling getuserdata: ' + strUserData)
        return JSON.parse(strUserData)
    },

    saveUserData(userData) {
        var strUserData = JSON.stringify(userData)
        localStorage.setItem(USER_DATA_KEY, strUserData)
    },

    removeUserData() {
        localStorage.removeItem(USER_DATA_KEY)
    },

    getRefreshToken() {
        return localStorage.getItem(REFRESH_TOKEN_KEY)
    },

    saveRefreshToken(refreshToken) {
        localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken)
    },

    removeRefreshToken() {
        localStorage.removeItem(REFRESH_TOKEN_KEY)
    },

    getMfaDeviceToken() {
        return localStorage.getItem(MFA_DEVICE_TOKEN_KEY)
    },

    saveMfaDeviceToken(token) {
        if (token) localStorage.setItem(MFA_DEVICE_TOKEN_KEY, token)
    },

    removeMfaDeviceToken() {
        localStorage.removeItem(MFA_DEVICE_TOKEN_KEY)
    }

}

export { TokenService }